import Controller from "./cityPaymentMethods.controller";
import template from "./cityPaymentMethods.html";

const cityPaymentMethods = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
  },
};

export default cityPaymentMethods;



// WEBPACK FOOTER //
// ./src/components/cityPaymentMethods/cityPaymentMethods.component.js